import { FC, memo, useCallback, useMemo } from "react";
const FormattedNumber: FC<{ value: string | number }> = memo(({ value }) => {
    const formatNumber = useCallback((input: string | number): string => {
        const str = String(input).trim();

        const [integerPart, decimalPart = ""] = str.split(".");

        if (!decimalPart || !decimalPart.match(/^0+/)) {
            return str.replace(".", ",");
        }

        const leadingZerosMatch = decimalPart.match(/^0+/);
        const leadingZerosCount = leadingZerosMatch ? leadingZerosMatch[0].length : 0;

        let rest = decimalPart.slice(leadingZerosCount);

        rest = rest.length > 4 ? rest.slice(0, 4) : rest;

        if (leadingZerosCount == 1) {
            return `${integerPart},0${rest}`;
        }
        return `${integerPart},0(${leadingZerosCount})${rest}`;
    }, []);

    const formattedValue = useMemo(() => {
        if (Number(value) > 1) {
            if (Number(value).toFixed(4).split(".")[1] === "0000") {
                return Number(value).toFixed(0);
            }
            return Number(value).toFixed(4);
        }

        const formatted = formatNumber(value);

        const parts = formatted.match(/^([^()]+)$$(\d+)$$(.*)$/) || [formatted, formatted, "", ""];
        return {
            beforeParentheses: parts[1],
            zeroCount: parts[2],
            afterParentheses: parts[3],
        };
    }, [value, formatNumber]);

    if (typeof formattedValue === "string") {
        return <span>{formattedValue}</span>;
    }

    const { beforeParentheses, zeroCount, afterParentheses } = formattedValue;

    return (
        <span>
            {beforeParentheses.length > 8 ? beforeParentheses.slice(0, 8) : beforeParentheses}
            {zeroCount && (
                <span style={{ fontSize: "0.95em", verticalAlign: "-0.1em", margin: "0 1px" }}>{zeroCount}</span>
            )}
            {afterParentheses.length > 4 ? afterParentheses.slice(0, 4) + "..." : afterParentheses}
        </span>
    );
});

FormattedNumber.displayName = "FormattedNumber";

export default FormattedNumber;
